import React from 'react';

const FormSelect = ({ label, id, name, value, onChange, options }) => (
  <div>
    <label htmlFor={id} className="gdl-form-label">{label}</label>
    <select
      id={id}
      name={name}
      value={value ?? ''}
      onChange={onChange}
      className="gdl-form-select"
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);

export default FormSelect;
